module.exports = __webpack_public_path__ + "img/partners_yingqiao.e59667cc.png";